<template>
  <cumulus-info-dialog
    v-model="dialogInfo"
    icon="$info"
    :title="$t('plane_informations')"
    color="info"
    avatar
    activator-icon
    @escape="closeDialog"
  >
    <template v-slot:info>
      <v-img
        v-if="plane.avatar"
        max-height="250px"
        :lazy-src="'data:image/jpeg;base64,' + plane.avatar.thumbnail"
        :src="dataUrl"
      />

      <v-card-title class="text-h5 blue lighten-3">
        {{ $t('plane_informations') }}
      </v-card-title>

      <v-card-text>
        <v-col>{{ $t('fields.model') }}: {{ plane.model }}</v-col>
        <v-col>{{ $t('fields.reg_num') }}: {{ plane.reg_num }}</v-col>
        <v-col>{{ $t('fields.manufacturer') }}: {{ plane.manufacturer }}</v-col>
        <v-col>{{ $t('fields.construction_date') }}: {{ plane.construction_date }}</v-col>
        <v-col>{{ $t('fields.serial_no') }}: {{ plane.serial_no }}</v-col>
      </v-card-text>

      <v-card-text v-if="planeInfo">
        <v-col>{{ $t('fields.flight_time') }}: {{ planeInfo.flight_time }}</v-col>
        <v-col>{{ $t('fields.landing') }}: {{ planeInfo.landing }}</v-col>
        <v-col>{{ $t('fields.engine_time') }}: {{ planeInfo.engine_time }}</v-col>
      </v-card-text>
    </template>
  </cumulus-info-dialog>
</template>

<script>

  import { call, get } from 'vuex-pathify'

  export default {
    name: 'PlaneInformations',
    props: {
      plane: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        dialogInfo: false,
        planeInfo: null,
      }
    },
    computed: {
      profile: get('plane/fetch'),
      dataUrl () {
        // return 'data:image/jpeg;base64,' + this.user.avatar.image
        return process.env.VUE_APP_API_URL + '/api/storage/avatar/' + this.plane.avatar_id
      },
    },
    watch: {
      dialogInfo (val) {
        if (this.dialogInfo) {
          this.setPlaneInfo(this.plane)
        }
        val || this.closeDialog()
      },
    },
    mounted () {
      /* UploadService.getFiles().then((response) => {
        this.fileInfos = response.data
      }) */
    },
    methods: {
      getPlaneInfo: call('plane/getPlaneInfo'),
      async setPlaneInfo (plane) {
        if (plane && this.planeInfo === null) {
          await this.getPlaneInfo(plane).then(response => {
            this.planeInfo = response
            console.log('plane_info' + this.planeInfo)
          }).catch(e => {
            console.log(e)
          })
        }
      },
      closeDialog () {
        this.dialogInfo = false
      },
    },
  }
</script>

<style lang="sass">
.v-dialog
  .v-card
    display: flex !important
    flex-direction: column

  .v-card__text
    flex-grow: 1
    overflow: auto
    // max-height: calc(100vh - 500px)
</style>
